import _ from 'lodash';

const leadNumber = (routeShortName) => {
  const rx = /^\d+/g;
  const x = String(routeShortName).toLowerCase().match(rx) || '9999';
  return parseInt(x, 10);
};
const suffix = (routeShortName) => {
  const rx = /^\d+/g;
  const x = String(routeShortName).toLowerCase().match(rx);
  if (!_.isEmpty(x)) {
    return routeShortName.substring(x.length);
  }
  return routeShortName;
};
/**
 * Sort short names of routes with both numbers and characters.
 * For example: ['9', '7', '9B', '11', '9A'] => ['7', '9', '9A', '9B', '11'].
 *
 * @param {*} shortNames category of the event. Please choose from CATEGORIES.
 * @return {*} label label of the event. Could be the target value of the event
 */
export default shortNames => _.orderBy(shortNames, [leadNumber, suffix]);
